export default __webpack_public_path__ + "static/media/file-active.ac9b73df.svg";